import type {FC} from 'react';

export const ExperienceCardSkeleton: FC<{className?: string}> = ({className}) => {
  return (
    <div
      className={`relative bg-[#31324B] p-2 flex flex-col gap-2 items-center h-full rounded-[20px] animate-pulse ${className}`}
    >
      {/* Image */}
      <div className="rounded-[20px] aspect-[1/1] w-full bg-white/20" />

      {/* Content */}
      <div className="flex flex-col gap-2 w-full pt-1 md:pt-2.5 p-2.5 flex-1">
        {/* Celebrity name */}
        <div className="flex items-center w-full justify-start gap-1.5">
          <div className="h-4 w-4 rounded-full bg-white/20 shrink-0" />
          <div className="h-3 md:h-4 bg-white/20 rounded w-24" />
        </div>

        {/* Experience name (2 lines) */}
        <div className="flex flex-col gap-1">
          <div className="h-4 tablet:h-5 bg-white/20 rounded w-full" />
          <div className="h-4 tablet:h-5 bg-white/20 rounded w-2/3" />
        </div>

        {/* Price + Button */}
        <div className="mt-auto md:pt-2 flex flex-col gap-3 md:gap-4">
          {/* Price */}
          <div className="flex items-center gap-1">
            <div className="h-6 md:h-7 bg-white/20 rounded w-20" />
            <div className="h-5 md:h-6 bg-white/20 rounded w-12" />
          </div>

          {/* Button */}
          <div className="h-[44px] md:h-[56px] bg-white/20 rounded-[14px] w-full" />
        </div>
      </div>
    </div>
  );
};
